import { GetWeavePopNotificationByType } from '@frontend/types';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

type Props = {
  onView?: (notification: GetWeavePopNotificationByType<'voicemail-message'>) => void;
};

export const useVoicemailNotification = ({ onView }: Props = {}) => {
  const { create, remove } = useNotification<'voicemail-message'>();
  useCommonActionSubscriptions('voicemail-message');

  useNotificationActionSubscription(
    'voicemail-message',
    'view',
    (e) => {
      onView?.(e.notification);
      remove(e.notification.id);
    },
    [onView]
  );

  return {
    create,
    remove,
  };
};
